var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "700pt",
    height: "700pt",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m350 46.668c-61.883 0-121.23 24.582-164.99 68.34-43.758 43.758-68.34 103.11-68.34 164.99s24.582 121.23 68.34 164.99c43.758 43.758 103.11 68.34 164.99 68.34s121.23-24.582 164.99-68.34c43.758-43.758 68.34-103.11 68.34-164.99-0.097656-61.855-24.711-121.14-68.449-164.88-43.738-43.738-103.03-68.352-164.88-68.449zm93.332 256.67-70-0.003907v70c0 8.3359-4.4453 16.039-11.664 20.207-7.2188 4.168-16.117 4.168-23.336 0-7.2188-4.168-11.664-11.871-11.664-20.207v-70h-70c-8.3359 0-16.039-4.4453-20.207-11.664-4.168-7.2188-4.168-16.117 0-23.336 4.168-7.2188 11.871-11.664 20.207-11.664h70v-70c0-8.3359 4.4453-16.039 11.664-20.207 7.2188-4.168 16.117-4.168 23.336 0 7.2188 4.168 11.664 11.871 11.664 20.207v70h70c8.3359 0 16.039 4.4453 20.207 11.664 4.168 7.2188 4.168 16.117 0 23.336-4.168 7.2188-11.871 11.664-20.207 11.664z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.9798335f731960d35bde69b2fddabb3a.svg";
export { ForwardRef as ReactComponent };